import { render, staticRenderFns } from "./DocumentMultiselect.vue?vue&type=template&id=21d5f2e1"
import script from "./DocumentMultiselect.vue?vue&type=script&lang=ts"
export * from "./DocumentMultiselect.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src4020427597/src/jobbliss-app-vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('21d5f2e1')) {
      api.createRecord('21d5f2e1', component.options)
    } else {
      api.reload('21d5f2e1', component.options)
    }
    module.hot.accept("./DocumentMultiselect.vue?vue&type=template&id=21d5f2e1", function () {
      api.rerender('21d5f2e1', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/autocompleteMultiselects/DocumentMultiselect.vue"
export default component.exports